import { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "../../../utils/classNames";

export interface TabOption {
  name: string;
  value: string;
}

export interface TabsProps {
  tabs: TabOption[];
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  ariaLabel?: string;
}

export default function DashboardStatTableTabs({ 
  tabs, 
  value, 
  onChange, 
  className = "",
  ariaLabel = "Tabs" 
}: TabsProps) {
  const { t } = useTranslation("common");
  const [internalValue, setInternalValue] = useState(() => {
    if (value) return value;
    // Default to first tab
    if (tabs.length > 0) {
      return tabs[0].value;
    }
    return '';
  });

  const currentValue = value || internalValue;

  const handleTabClick = (tabValue: string) => {
    if (onChange) {
      onChange(tabValue);
    } else {
      setInternalValue(tabValue);
    }
  };

  return (
    <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          {t("Select a tab")}
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-primary-500 focus:outline-none focus:ring-primary-500 sm:text-sm"
          value={currentValue}
          onChange={(e) => handleTabClick(e.target.value)}
        >
          {tabs.map((tab: TabOption) => (
            <option key={tab.value} value={tab.value}>
              {tab.name}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-6" aria-label={ariaLabel}>
            {tabs.map((tab: TabOption) => {
              const isActive = tab.value === currentValue;
              
                              return (
                  <button
                    key={tab.value}
                    onClick={() => handleTabClick(tab.value)}
                    className={classNames(
                      isActive
                        ? 'border-primary-500 text-primary-600'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                      'whitespace-nowrap border-b-2 py-1 px-1 text-sm font-medium'
                    )}
                    aria-current={isActive ? 'page' : undefined}
                  >
                    {tab.name}
                  </button>
                );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
} 